import { BusinessRequest, BusinessCustomRequestOptions } from "../utils";

const apis = {
  compony: {
    prefix: "/api/manager",

    /**
     * @description 新增公司
     * @alias /api/manager/company
     * @doc http://dev.secp.192.168.221.92.nip.io/api/manager/doc.html#/后台管理/关联公司/createCompanyUsingPOST
     */
    create: {
      post: "/company",
    },
    /**
     * @description 修改公司
     * @alias /api/manager/company/{id}
     * @doc http://dev.secp.192.168.221.92.nip.io/api/manager/doc.html#/后台管理/关联公司/editCompanyUsingPUT
     */
    update: {
      put: "/company/{id}",
    },

    /**
     * @description 获取最多可新增的银行账号数量
     * @alias /api/manager/company/bank/account/limit
     * @doc https://test.we.goodwe.com/api/manager/doc.html#/%E5%90%8E%E5%8F%B0%E7%AE%A1%E7%90%86/%E5%85%B3%E8%81%94%E5%85%AC%E5%8F%B8/getBankAccountLimitUsingGET
     */
    limit: {
      get: "/company/bank/account/limit",
    },

    /**
     * @description 根据id获取公司详情
     * @alias /api/manager/company/{id}
     * @doc https://test.we.goodwe.com/api/manager/doc.html#/%E5%90%8E%E5%8F%B0%E7%AE%A1%E7%90%86/%E5%85%B3%E8%81%94%E5%85%AC%E5%8F%B8/getCompanyInfoByIdUsingGET
     */
    companyDetail: {
      get: "/company/{id}",
    },
  },
};

const request = new BusinessRequest(apis, BusinessCustomRequestOptions);

export { apis };
export default request.useRequest;
